<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-tags title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.organizations' | transloco}}</p>
            <p>
              {{(mode == 'create' ? 'misc.creation.organization' : 'misc.edition.organization') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div *ngIf="!isLoadingOrganization && organizationForm">
        <form [formGroup]="organizationForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="name" id="name" pInputText type="text">
              </div>
              <app-validation-errors [control]="organizationForm.get('name')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="orgCode">{{'attribute.orgCode' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="orgCode" id="orgCode" pInputText type="text">
              </div>
              <app-validation-errors [control]="organizationForm.get('orgCode')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="email">{{'attribute.email' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="email" id="email" pInputText type="text">
              </div>
              <app-validation-errors [control]="organizationForm.get('email')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}}:</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="description" id="description" pInputText type="text">
              </div>
              <app-validation-errors [control]="organizationForm.get('description')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organizationType">{{'attribute.organizationType' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown
                  [placeholder]="'select.organizationType' | transloco"
                  [options]="organizationTypes"
                  [showClear]="true"
                  [filter]="true" filterBy="name"
                  styleClass="w-full"
                  optionLabel="name"
                  optionValue="organizationTypeUuid"
                  id="organizationType"
                  formControlName="organizationType"
                ></p-dropdown>
              </div>
              <app-validation-errors [control]="organizationForm.get('organizationType')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="parent">{{'attribute.organizationParent' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-treeSelect
                  [(ngModel)]="selectedParent"
                  [placeholder]="'select.organization' | transloco"
                  [options]="hierarchy"
                  [ngModelOptions]="{standalone: true}"
                  id="parent"
                ></p-treeSelect>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="phone">{{'attribute.phone' | transloco}}:</label>
              </div>
              <div class="col-12">
                <ngx-intl-tel-input
                  [cssClass]="'w-full'"
                  [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="true"
                  [searchCountryPlaceholder]="'search.byCountry' | transloco"
                  [searchCountryFlag]="true"
                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                  [selectFirstCountry]="true"
                  [separateDialCode]="true"
                  [maxLength]="15"
                  [phoneValidation]="true"
                  [inputId]="'phone'"
                  [numberFormat]="PhoneNumberFormat.International"
                  formControlName="phone"
                  id="phone"
                ></ngx-intl-tel-input>
              </div>
              <app-validation-errors [control]="organizationForm.get('phone')"></app-validation-errors>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="locality">{{'search.byLocality' | transloco}}:</label>
              </div>
              <div class="col-12">
                <div id="geocoder"></div>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="address">{{'attribute.address' | transloco}}:</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="address" id="address" pInputText type="text">
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="locality">{{'attribute.locality' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="locality" id="locality" pInputText type="text">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="state" id="state" pInputText type="text">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="country">{{'attribute.country' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="country" id="country" pInputText type="text">
              </div>
            </div>
          </div>
        </form>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <button
                  [label]="'common.cancel' | transloco"
                  [routerLink]="'/organizations'"
                  pButton
                  class="p-button-danger"
                  iconPos="right"
                ></button>
                <p-button
                  [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
                  [disabled]="!organizationForm?.valid || !this.selectedParent || !this.organizationForm.get('locality').value"
                  [loading]="persistingChanges"
                  (onClick)="persistOrganizationData()"
                  styleClass="p-button-primary"
                ></p-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoadingOrganization || organizationForm == null">
        <div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="name">{{'attribute.name' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="email">{{'attribute.email' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="description">{{'attribute.description' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organizationType">{{'attribute.organizationType' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="parent">{{'attribute.organizationParent' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="phone">{{'attribute.phone' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="locality">{{'search.byLocality' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="address">{{'attribute.address' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="locality">{{'attribute.locality' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="country">{{'attribute.country' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <div class="w-6rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
                <div class="w-6rem">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
